export default "__VITE_PUBLIC_ASSET__c0624168__"